import React from 'react';

const GeneralInfo = () => {
    return (
        <div className="container pt-5">
        <div className="border row border-4 text-lg-start text-md-center text-center border-dark align-items-center">
       <div className="col-md-4">
       <img src="Course-details.png" className='rounded img-fluid my-sm-3 my-3' alt="" />
       </div>
        <div className="details col-md-8">
           <div className="div ps-lg-3 ps-md-0 ps-0 ms-3 my-2">
           <h4>Name: Md. Rasel Molla</h4>
            <h5>MERN Stack Developer</h5>
            <p className='mb-0'>A career in computer programming requires an aptitude for technology, science, and math. Additionally, patience and problem-solving skills are essential, as writing and testing code is a complex and sometimes stressful process. 
                </p>
           </div>
            </div>
        </div>
        </div>
    );
};

export default GeneralInfo;